<!-- TODO please revisit the class asignments to support BEM standards -->
<div class="image-cropping" [ngClass]="{ 'image-cropping--sidenav': isSideNavStyle }">
  <div class="image-cropping__header">
    <button *ngIf="!isSideNavStyle" (click)="onCloseDialog()" class="image-cropping__closeButton p-0">
      <mat-icon>close</mat-icon>
    </button>
    <h1>{{ title | translate }}</h1>
  </div>
  <div class="container image-cropping__container" [ngClass]="{ 'crop-bg': flag }">
    <ng-container *ngIf="profileImageUrl && !showCropperByUrl; else uploadImageMain">
      <div class="image-cropping__profile-img">
        <div class="image-cropping__profile-img-container">
          <img loading="lazy" [src]="profileImageUrl" (error)="handleImageError($event)" />
          <mat-icon (click)="removeCropImage()" data-cy="delete-icon">delete</mat-icon>
        </div>
      </div>
    </ng-container>
    <ng-template #uploadImageMain>
      <div
        class="image-cropper"
        [ngClass]="{ 'image-cropper--sidenav':  isSideNavStyle }"
        *ngIf="(imageChangedEvent || showCropperByUrl);"
      >
        <div class="image-cropper__preview">
          <image-cropper
            *ngIf="(imageChangedEvent || showCropperByUrl)"
            [imageChangedEvent]="imageChangedEvent"
            [maintainAspectRatio]="true"
            [aspectRatio]="1 / 1"
            format="png"
            [containWithinAspectRatio]="true"
            [imageURL]="profileImageUrl"
            [backgroundColor]="'#707073'"
            [autoCrop]="autoCrop"
            [(transform)]="transform"
            (imageCropped)="imageCropped($event)"
            (imageLoaded)="imageLoaded()"
            [style.display]="imageLoadedValue ? null : 'none'"
            (cropperReady)="cropperReady()"
          ></image-cropper>
          <ng-container *ngIf="imageLoadedValue; else spinner"> </ng-container>
        </div>
        <div class="image-cropper__settings">
          <div class="image-cropper__settings-sliders">
            <div>
              <span class="image-cropper__settings-label"> Zoom </span>
              <mat-slider
                thumbLabel
                [displayWith]="formatLabel"
                [(ngModel)]="zoom"
                [tickInterval]="getZoomSliderTickInterval()"
                tickInterval="0.1"
                step="0.1"
                min="1"
                max="2"
                aria-label="units"
              ></mat-slider>
            </div>
            <div>
              <span class="image-cropper__settings-label"> Rotate </span>
              <mat-slider
                thumbLabel
                [displayWith]="formatLabel"
                [(ngModel)]="rotation"
                [tickInterval]="getRotationSliderTickInterval()"
                tickInterval="5"
                step="5"
                min="-180"
                max="180"
                aria-label="units"
              ></mat-slider>
              <cm-basic-button
                [mode]="BasicButtonModes.OUTLINED"
                [color]="BasicButtonsColor.PRIMARY"
                [disabled]="rotation === 0 && zoom === 1 "
                *ngIf="(imageChangedEvent || !profileImageUrl)"
                (click)="resetImageTransform()"
                >Reset
              </cm-basic-button>
            </div>
          </div>
          <div class="image-cropper__settings-preview">
            <span class="image-cropper__settings-label"> Preview </span>
            <div class="image-cropper__settings-remove-image">
              <ng-container *ngIf="imageLoadedValue; else spinner">
                <img *ngIf="croppedImage" [src]="croppedImage" style="width: 74px; height: 74px" />
              </ng-container>
              <mat-icon (click)="removeCropImage()">delete</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <div>
        <cm-file-upload
          #fileUpload
          type="profileImage"
          hideInputWhileUpload="true"
          [fileSizeLimitMB]="25"
          (fileChanged)="fileChangeEvent($event)"
          (removeFile)="removeImage($event)"
          (urlUpdated)="uploadImage($event)"
          (fileLoadingFlag)="setLoading($event)"
          [fileType]="FileTypeEnum.PROFILE"
          [removeAfterUpload]="removeAfterUpload"
          [uploadFlow]="false"
          [cropImage]="cropImage"
          [style.display]="(imageChangedEvent ? 'none' : 'block')"
        >
        </cm-file-upload>
      </div>
    </ng-template>
  </div>
  <div class="image-cropping__footer d-flex">
    <cm-basic-button
      mat-dialog-close
      *ngIf="!isSideNavStyle"
      [mode]="BasicButtonModes.FLAT"
      [color]="BasicButtonsColor.PRIMARY"
      >Cancel
    </cm-basic-button>

    <div class="d-flex gap-3">
      <cm-basic-button
        [mode]="BasicButtonModes.OUTLINED"
        [color]="BasicButtonsColor.PRIMARY"
        *ngIf="profileImageUrl && !showCropperByUrl"
        (click)="editProfilePicture()"
        >Edit Photo
      </cm-basic-button>
      <cm-basic-button
        [mode]="BasicButtonModes.PRIMARY"
        [color]="BasicButtonsColor.PRIMARY"
        *ngIf="profileImageUrl && !showCropperByUrl"
        (click)="removeCropImage()"
        >Add New Photo
      </cm-basic-button>
    </div>

    <cm-basic-button
      [mode]="BasicButtonModes.PRIMARY"
      [color]="BasicButtonsColor.PRIMARY"
      *ngIf="(imageChangedEvent || !profileImageUrl || isEditingPhoto)"
      (click)="uploadCroppedImage()"
      [dataCy]="'update-photo-button'"
      >Update Photo
    </cm-basic-button>
  </div>
</div>
<!-- spinner -->
<ng-template #spinner>
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
